var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAdmins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 138,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty state",
    clipPath: "url(#clip0_10535_3504)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1025,
    transform: "translate(-777 -277)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 5149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 5147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5590"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123",
    cx: 69,
    cy: 69,
    r: 69,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 112",
    d: "M33.6512 49.4094C31.8294 60.9475 31.7724 82.2159 31.9967 93.0516C32.0205 94.2057 32.6627 95.2567 33.7088 95.7447C40.003 98.6806 53.6825 103.149 69.4901 102.564C84.9436 101.991 97.304 98.199 103.071 95.7595C104.221 95.2731 104.907 94.1201 104.876 92.8719C104.587 81.1637 104.022 59.3131 103.718 51.4228C103.316 40.953 92.0405 18 69.4901 18C46.9398 18 36.0673 34.1074 33.6512 49.4094Z",
    fill: "#694F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 115",
    d: "M48.8171 112.631L29.4883 125.517C34.4547 129.678 50.589 138 68.9514 138C87.3138 138 102.374 129.678 108.012 125.517L87.0722 112.631H48.8171Z",
    fill: "#F16959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 114",
    d: "M49.6226 114.241C54.7769 110.698 55.2601 102.832 54.8575 99.3418H80.6293C79.3407 107.073 84.1192 112.496 86.6695 114.241C85.4615 117.194 80.146 123.1 68.5487 123.1C56.9514 123.1 51.0991 117.194 49.6226 114.241Z",
    fill: "#ECC396"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 125",
    cx: 42.7768,
    cy: 73.1679,
    r: 6.84564,
    fill: "#ECC396"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 126",
    cx: 93.5151,
    cy: 73.1679,
    r: 6.84564,
    fill: "#ECC396"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 124",
    cx: 68.1459,
    cy: 67.9333,
    rx: 28.1879,
    ry: 35.4362,
    fill: "#F7CFA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 113",
    d: "M81.032 44.98C69.3541 54.6444 49.7568 57.4632 40.3608 57.8659C42.3743 38.537 59.6897 25.6511 82.24 30.886C100.28 35.0739 101.166 58.2686 97.542 67.5303C98.5085 54.3223 90.1595 44.5773 85.8642 41.3558C84.8978 52.3088 76.6025 55.584 72.5756 55.8525C77.0857 54.5639 80.0924 48.0672 81.032 44.98Z",
    fill: "#694F44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5588"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 121",
    cx: 105.266,
    cy: 126.266,
    r: 11.2662,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "+",
    d: "M108.078 126.98H106.034V129.078H104.607V126.98H102.562V125.661H104.607V123.562H106.034V125.661H108.078V126.98Z",
    fill: "white"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10535_3504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1025,
    fill: "white",
    transform: "translate(-777 -277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAdmins);
export default __webpack_public_path__ + "static/media/emptyAdmins.3039d001bc6024d46735006c981392c7.svg";
export { ForwardRef as ReactComponent };